import React, {useRef} from 'react'
import {
  CloseButton,
  StyledBody,
  StyledCard,
  StyledHeader,
  StyledModal,
  StyledText,
  StyledTitle,
} from './LargeRectangleModal.styled'
import PropTypes from 'prop-types'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import useOutsideClick from "../../hooks/useOutsideClick";

const LargeRectangleModal = (props) => {
  const {show, onClose, card} = props
  if (!show) {
    return null
  }

  const wrapperRef = useRef(null)
  useOutsideClick(wrapperRef, onClose)

  return (
    <StyledModal>
      <StyledCard ref={wrapperRef}>
        <StyledBody>
          <StyledHeader>
            <StyledTitle>{card.title?.title ?? ''}</StyledTitle>
            <CloseButton onClick={() => onClose()}/>
          </StyledHeader>
          <StyledText>
            <CKEditorContent html={card.textHtml.content}/>
          </StyledText>
        </StyledBody>
      </StyledCard>
    </StyledModal>
  )
}

LargeRectangleModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
}

export default LargeRectangleModal
